import React from 'react';
import styles from './AssessmentStatusTable.module.css';

const AssessmentStatusBadge = ({ status }) => {
  const classMap = {
    pending: styles.statusPending,
    approved: styles.statusApproved,
    rejected: styles.statusRejected,
  };
  const label = status ? status.charAt(0).toUpperCase() + status.slice(1) : '';
  return (
    <span
      className={`${styles.statusBadge} ${classMap[status] || styles.statusPending}`}
    >
      {label}
    </span>
  );
};

export default AssessmentStatusBadge;
